import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { modelHeadersDetails } from '../Model/ModelHeadersDetails';
import CustomModal from '../../../components/Modal/CustomModal';
import { DetailsList } from '../Subcomponent/DetailsList';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DataDetailsModal = ({ openModal, handleCloseModal, dataDetail, selectedModel }) => {
    const { t } = useTranslation();

    // Retrieves the headers corresponding to the selected model to show data
    const headersToShow = modelHeadersDetails[selectedModel] || [];

    return (
        <CustomModal
            show={openModal}
            onHide={handleCloseModal}
            title='data_details'
            confirmButton={false}
            cancelButton={true}
        >
            <Box>
                <h4 className='text-secondary fw-medium text-center fs-6 mt-3 mb-4'>
                    <span className='text-uppercase ibl-font-w-600'>{t(selectedModel).toUpperCase()}*</span>
                    &nbsp; {t('record_details').toUpperCase()}
                </h4>
            </Box>
            <Box className='hard-delete-data'>
                <DetailsList data={dataDetail} headers={headersToShow} />
            </Box>
        </CustomModal>
    );
};

export default DataDetailsModal;
